/**
*
*/
<template>
	<div>
		<!-- 面包屑导航 -->
		<router-view />
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>{{Name}}</el-breadcrumb-item>
		</el-breadcrumb>
		<el-card style="margin-top: 20px;">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="搜索：">
					<el-select v-model="formInline.BIllName" clearable filterable placeholder="请选择过滤条件 "
						style="display: block;height: 90%;" size="small">
						<el-option v-for="item in tableLabel" :key="item.item" :value-key="item.item" :label="item.label"
							:value="item.item">
							<span style="float: left; color: #8492a6; font-size: 17px">{{
				                  item.label
				                }}</span>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input size="small" v-model="formInline.deptName" placeholder="过滤值"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="getdata()">搜索</el-button>
					<el-button size="small" type="primary" icon="el-icon-search" @click="insertd()">新增</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!--列表-->

		<el-card style="margin-top: 20px;">
			<el-table ref="multipleTable" :data="listinData.slice((currentPage - 1) * pagesize, currentPage * pagesize)" border id="el-table" v-loading="loading" class="demo-Form" :highlight-current-row="false"
				height="800px" element-loading-text="拼命加载中" style="width: 100%;"  :key="itemKey"
				@selection-change="handleSelectionChange"
				:header-cell-style="{'text-align':'center'}" >
		<el-table-column align="center" label="二维码" >
        <template slot-scope="scope">
            <qrcode :value="`https://rifengczyxzx.com/YPSoft/userid=${scope.row.LItemID}`" :options="{ size: 100 }" >
            </qrcode>
        </template>
    </el-table-column>
				<el-table-column align="center" sortable prop="LName" label="客户名称" >
				</el-table-column>
				<el-table-column align="center" sortable prop="LFenX" label="分销商" >
				</el-table-column>
				<el-table-column align="center" sortable prop="LPhone" label="手机号" >
				</el-table-column>
				<el-table-column align="center" sortable prop="LCount" label="当前可用积分">
				</el-table-column>
				<el-table-column align="center" sortable prop="LMone" label="当前可用货值">
				</el-table-column>
				<el-table-column align="center" sortable prop="LRemark" label="备注">
				</el-table-column>
				<el-table-column align="center" label="是否启用" prop="LIsUse" >
               <template slot-scope="scope">
				<el-switch
				v-model="scope.row.LIsLock"
				active-color="#13ce66"
				inactive-color="#ff4949"
				active-value="true"
				inactive-value="false"
				@change="upuse(scope.row)">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column align="center"  prop="contuil" label="操作">
					<template slot-scope="scope">
					 <el-button type="warning" size="small" @click="spearchange(scope.row)">修改</el-button>
					 <el-button type="primary"  size="small" @click="spear(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="block">
				<el-pagination align="center" @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[5,10,15,20]" :page-size="pagesize"
					layout="total, sizes, prev, pager, next, jumper" :total="listinData.length">
				</el-pagination>
			</div>
		</el-card>

		<el-dialog :title="title" :visible.sync="editFormVisible" width="30%">
      <el-form label-width="80px" ref="editForm" :model="editForm" >
        <el-form-item label="客户名称" prop="CPName">
          <el-input size="small" v-model="editForm.userName" auto-complete="off" placeholder="请输入客户名称"></el-input>
        </el-form-item>
         <el-form-item label="分销商" prop="LMone">
          <el-input  size="small" v-model="editForm.deptNo" placeholder="请输入分销商"></el-input>
        </el-form-item>
        <el-form-item label="客户电话" prop="LMone">
          <el-input type="number" size="small" v-model.number="editForm.deptId" placeholder="请输入客户电话"></el-input>
        </el-form-item>
		<el-form-item label="备注" prop="LReamrk">
          <el-input size="small" v-model="editForm.LReamrk" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="flase()">取消</el-button>
        <el-button size="small" type="primary"  @click="submitForm('editForm')">保存</el-button>
      </div>
			</el-dialog>
	</div>
</template>
<script>
	import {
		deptList,
		deptSave,
		deptDelete,
		login,
		GetLB,
		accountset,
		LinkQueryApp,
		LinkUpNextApp,
		OperateBill
	} from '../../api/userMG'
	import Pagination from '../../components/Pagination'
	import axios from 'axios';
	import FileSaver from 'file-saver'
	import XLSX from 'xlsx'
	import Qrcode from '@xkeshi/vue-qrcode'
	export default {

		data() {
			return {
				centerDialogVisible: false,
				v_str_AccountID: '165',
				nshow: true, //switch开启
				fshow: false, //switch关闭
				loading: false, //是显示加载
				load: false,
				editFormVisible: false, //控制编辑页面显示与隐藏
				//upselect: false,
				title: '添加',
				tableDataLIe: [],
				listinData: [],
				readonly: true,
				gridData: [],
				editForm: {
					deptId: '',
					userName: '',
					deptNo: '',
					token: localStorage.getItem('logintoken'),
					LReamrk:""
				},
				dialogFormVisible: false,
				dailogTitleType1: '目标单据',
				dialogFormVisible1: false,
				sumlist: [],
				currentPage: 1, //默认显示第一页
				pagesize: 15, //默认每页显示10条
				totalNum: 0, //总页数
				cless: '',
				tableLabel:[{
				 item:'客户名称',
				 label:'客户名称'
				},{
				 item:'客户手机号',
				 label:'客户手机号'
				}],
				selectOptions: [],
				dept: [],
				radio: '',
				danju: ' ',
				L_MaterialName: '',
				mergeObj: {},
				needMergeArr: ['L_BillNo','L_BatchNo','jindu','contuil'],
				rowMergeArrs: [],
				upnext: '',
				formInline: {
					page: 1,
					limit: 10,
					varLable: '',
					varName: '',
					BIllName:'客户名称',
					deptName:'',
					token: localStorage.getItem('logintoken'),
					data: [
						[{}]
					]
				},
				SysId: 1,
				billNO: '',
				listData: [], //用户数据
				multipleSelection: [],
				consioData2: [],
				consioData3: [],
				consioData: [],
				Name: '',
				v_str_AccountID:165,
				currentSort: "0",
				currentSorts: "0",
				itemKey: 0,
			}
		},
		// 注册组件
		components: {
			Pagination,
			"qrcode": Qrcode
		},

		/**
		 * 数据发生改变
		 */
		/**
		 * 创建完毕
		 */
		watch: {
			'$route'(to, from) {
				this.$router.go(0);
				//  console.log(to)
			}
		},
		created() {
			if (this.$route.query) {
				this.cless = this.$route.query.LItemID.FParams
      }
      this.getdata()
		},

		/**
		 * 里面的方法只有被调用才会执行
		 */
		methods: {
				flase(){
				this.editFormVisible=false;
			},
			upuse(row){
				console.log(row)
				let status;
				if(row.LIsUse==1){
            status="停用"
				}else{
             status="启用"
				}
			this.$confirm('此操作将'+status+'该人员, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
					}).then(() => {
					 let phems={
							'v_str_AccountID': this.v_str_AccountID,
							'jsSQL':"{\"SQL\":[{\"update\":\" update A_Kh set LIsUse='"+row.LIsLock+"' where LItemID='"+row.LItemID+"'  \"}]}"
						}
					login(phems).then(res => {
						if(res.Result=="Y"){
							this.$message({
								type: 'sucess',
								message: status+ "成功"
							});
							}else{
							this.$message({
								type: 'error',
								message: status+ "失败"
							});
						}
						})
					     this.getdata();
					}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
					});
			},
			spearchange(row){
				this.SysId=2
				this.radio=row.LItemID
				this.editForm.userName=row.LName,
				this.editForm.deptNo=row.LFenX,
				this.editForm.deptId=row.LPhone,
				this.editForm.LReamrk=row.LReamrk,
                this.editFormVisible=true
			},
			spear(row){
				this.$confirm('此操作将删除该人员, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
					}).then(() => {
					 let phems={
							'v_str_AccountID': this.v_str_AccountID,
							'jsSQL':"{\"SQL\":[{\"delete\":\" delete from  A_Kh where LItemID='"+row.LItemID+"'  \"}]}"
						}
					login(phems).then(res => {
						if(res.Result=="Y"){
							this.$message({
								type: 'sucess',
								message: status+ "成功"
							});
							}else{
							this.$message({
								type: 'error',
								message: status+ "失败"
							});
						}
						})
					     this.getdata();
					}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
					});
			},
		  insertd(){
			 this.SysId=1
             this.editFormVisible=true;
			},
			submitForm(){
				let phems
				if(this.SysId==1){
					phems={
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL':"{\"SQL\":[{\"insert\":\" insert into A_Kh (LName,LPhone,LFenx,LRemark,LIsUse)values ('"+this.editForm.userName+"','"+this.editForm.deptId+"','"+this.editForm.deptNo +"','"+this.editForm.LReamrk+"','1') \"}]}"
					}
				}else{
					if(this.editForm.deptNo==null ||this.editForm.deptNo==undefined)this.editForm.deptNo="";
					if(this.editForm.LReamrk==null ||this.editForm.LReamrk==undefined)this.editForm.LReamrk="";
					phems={
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL':"{\"SQL\":[{\"update\":\" update A_Kh set LName='"+this.editForm.userName+"',LPhone='"+this.editForm.deptId+"',LFenx='"+this.editForm.deptNo +"',LRemark='"+this.editForm.LReamrk+"' where LItemID='"+this.radio+"'  \"}]}"
				  }
				}
			login(phems).then(res => {
			 if(res.Result=="Y"){
				 this.$message({
					type: 'sucess',
					message: "成功"
				});
			 	}else{
			     this.$message({
					type: 'error',
					message: "失败"
				});
		     }
			})
			this.getdata();
			},
			tabsop() {
				this.moui = 1
			},
			tabsops() {
				this.moui = 0
			},
			handleSizeChange(val) {
				this.pagesize = val;
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				let litdata=this.listinData.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			trceshi(row) {
			},
			handleRowClick(row, column, event) {
				this.$refs.multipleTable.toggleRowSelection(row);
			},
			nowdate(){
				var  date =  new  Date();
				var  year = date.getFullYear();
				var  month = date.getMonth() + 1;
				var  day = date.getDate();
				var  hour = date.getHours();
				var  minute = date.getMinutes();
				var  second = date.getSeconds();
				let  nowdate=year +  '-'  + month +  '-'  + day  +  ' '  + hour +  ':'  + minute +  ':'  + second;
				return nowdate
			},
			lastweekdate(){
			var  now =  new  Date();
			var  date =  new  Date(now.getTime() - 7 * 24 * 3600 * 1000);
			var  year = date.getFullYear();
			var  month = date.getMonth() + 1;
			var  day = date.getDate();
			var  hour = date.getHours();
			var  minute = date.getMinutes();
			var  second = date.getSeconds();
			let  lastweekdate=year +  '-'  + month +  '-'  + day  +  ' '  + hour +  ':'  + minute +  ':'  + second;
			return lastweekdate
			},
		async getdata(){
		     this.loading=true
			   //调用倒计时方法 key 自动加一

		     let TableLine = [],datjin="";
				let selectOnline = [];
				let dat="",why="";
				if(this.formInline.BIllName=='客户名称'){
					dat='LName'
				}else if(this.formInline.BIllName=='客户手机号'){
					dat='LPhone'
				}
				if(this.formInline.deptName!=''){
					dat=dat+" like '%"+this.formInline.deptName+"%'"
				}else{
					dat='1=1'
				}
				let phemss = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"SELECT\":\" SELECT top 50 * FROM A_Kh where "+dat +"  order by LItemID \"}]}"
				}
				await login(phemss).then(async res => {
					let arr = res.Data.Table
					for(let i=0;i<arr.length;i++){
						let item=arr[i]

						let  modata = {
						'v_str_AccountID': this.v_str_AccountID,
						'jsSQL': "{\"SQL\":[{\"SELECT\":\"select  sum(LCount) as LCount,LType from  v_INout where LUserID='"+item.LItemID+"' group by LType; select  sum(LCount) as LCount,LType from  v_WL where LUserID='"+item.LItemID+"' group by LType  \"}]}"
						}
					 await	login(modata).then(rem=>{
							let arr=rem.Data.Table;
							let arr1=rem.Data.Table1;
							let inout=0,outin=0;
							let inouh=0,outinh=0;
							if(arr.length>0){
								arr.forEach(items=>{
								if(items.LType=="充值"){
								inout=items.LCount
								}else{
								outin=items.LCount
								}
							})
							}
							if(arr1.length>0){
								arr1.forEach(items=>{
								if(items.LType=="充值"){
								inouh=items.LCount
								}else{
								outinh=items.LCount
								}
							})
							}
              item['LCount']=Number(inout)-Number(outin)
						  item['LMone']=Number(inouh)-Number(outinh)
						})
						item['LIsLock']= JSON.stringify(item.LIsUse)
					}
					console.log(arr)
					this.listinData = arr
					})
					this.itemKey!=this.itemKey
				    this.loading=false
           },
           giveCharData(index) {
				if (this.currentSorts === index) {
					return false;
				}
				this.currentSorts = index;
			},
			getMath(mst){
				const result = this.listinData.filter(u => u.L_BillNo ==mst.L_BillNo )
				let stmath=0
				result.forEach((item)=>{
					if(item.zt!=0){
						stmath++
					}
				})
				return  Math.ceil((stmath/result.length)*100)
			},
			mergeAction(val, rowIndex) {
			    let _row = this.rowMergeArrs[val].rowArr[rowIndex];
			    let _col = _row > 0 ? 1 : 0;
			    return [_row, _col];
			},
			async search(){
					this.getPath()
				},
			objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			    for(let res in this.needMergeArr){
			        if(this.needMergeArr[res] == column.property){
			            return this.mergeAction(column.property, rowIndex, columnIndex);
			        }
			    }
			},

			seedefor() {
				this.centerDialogVisible = true
			},
			async getPath(plant) {

			},
		}
	}
</script>

<style scoped>
	.user-search {
		margin-top: 20px;
	}
 .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
	.userRole {
		width: 100%;
	}

	.active {
		background: #409eff;
		color: #fff;
	}

	.demo-ruleForm>>>.el-input__inner {
		border: 0;
		background-color:
			#FFF;
		color: #606266;
		/*text-align: center;*/
	}

	.demo-Form>>>.el-table__body tr:hover>td.el-table__cell {
		background-color: #FFF !important;
	}

	.demo-Form>>>.el-table__cell {
		padding: 5px;

	}

	.demo-ruleForm>>>.el-icon-arrow-up:before {
		content: '' !important;
	}

	.demo-ruleForm>>>.el-card__body {
		padding-top: 0px;
	}

	.demo-ruleForm>>>.el-table__body-wrapper {
		height: calc(100% - 70px) !important;
	}

	/deep/.el-popper[x-placement^=bottom] .popper__arrow::after {
		border-bottom-color: transparent;
	}

	/deep/.el-popper .popper__arrow,
	.el-popper .popper__arrow::after {
		border-style: none !important;
	}

	/deep/.el-table__footer-wrapper tbody td.el-table__cell {
		font-size: 1px;
	}

	/deep/.el-table .el-table__footer-wrapper .cell {
		font-size: 1px;
	}
</style>



// WEBPACK FOOTER //
// src/views/machine/MachineConfig.vue